import { render } from "./PopModel.vue?vue&type=template&id=57132b8c&scoped=true"
import script from "./PopModel.vue?vue&type=script&lang=js"
export * from "./PopModel.vue?vue&type=script&lang=js"

import "./PopModel.vue?vue&type=style&index=0&id=57132b8c&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57132b8c"]])

export default __exports__